import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaGamepad, FaUsers, FaUser } from 'react-icons/fa';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #2d3436;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: #74b9ff;
  text-decoration: none;
  
  span {
    margin-left: 0.5rem;
  }
`;

const Menu = styled.div`
  display: flex;
  gap: 2rem;
`;

const MenuItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: #dfe6e9;
  font-weight: 500;
  transition: color 0.2s;

  &:hover {
    color: #74b9ff;
  }

  svg {
    font-size: 1.2rem;
  }
`;

const Navbar: React.FC = () => {
  return (
    <Nav>
      <Logo to="/">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="15" fill="#2D3436" stroke="#74b9ff" stroke-width="2"/>
          <circle cx="10" cy="16" r="3" fill="#74b9ff"/>
          <circle cx="22" cy="16" r="3" fill="#74b9ff"/>
          <circle cx="16" cy="10" r="3" fill="#74b9ff"/>
          <circle cx="16" cy="22" r="3" fill="#74b9ff"/>
          <circle cx="16" cy="16" r="2" fill="#2D3436"/>
        </svg>
        <span>armen138.online</span>
      </Logo>
      <Menu>
        <MenuItem to="/">
          <FaGamepad />
          Games
        </MenuItem>
        <MenuItem to="/social">
          <FaUsers />
          Social
        </MenuItem>
        <MenuItem to="/about">
          <FaUser />
          About
        </MenuItem>
      </Menu>
    </Nav>
  );
};

export default Navbar; 